module.exports = __webpack_public_path__ + "img/filter-location.89b7c44c.png";